module.exports = __webpack_public_path__ + "media/call3.e650a5ea.mp4";